import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=74ad2ac0"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ad2ac0')) {
      api.createRecord('74ad2ac0', component.options)
    } else {
      api.reload('74ad2ac0', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=74ad2ac0", function () {
      api.rerender('74ad2ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/components/upload.vue"
export default component.exports